/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const WorldIconOutline = createIcon({
  displayName: 'WorldIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,3c4.982,0 9,4.018 9,9c0,4.982 -4.018,9 -9,9"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,21c-4.982,0 -9,-4.018 -9,-9c0,-4.982 4.018,-9 9,-9"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.168,4.06c-2.89,4.825 -2.89,11.056 0,15.881c0.846,1.413 2.819,1.413 3.665,0c2.89,-4.825 2.89,-11.056 0,-15.881c-0.847,-1.413 -2.819,-1.413 -3.665,8.88178e-16Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.01,7.858c4.892,1.511 11.088,1.511 15.979,0"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.99,16.142c-4.892,-1.511 -11.088,-1.511 -15.979,0"
        ></path>
      </g>
    </>
  ),
})

const World: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={WorldIconOutline} {...props} />
  }
}

export default memo(World)
